import React from 'react';
import ReactDOM from 'react-dom';
import { PageTemplate } from './PageTemplate';

export const Contact = () => {
    const mainContent =
        <React.Fragment>
            <div className="flex flex-col justify-around mt-4 mb-8 text-center">
                <h3 className='text-2xl mb-6'>Kde nás najdete?</h3>
                <div className="w-full text-center font-bold">
                    <p>Malá poliklinika</p>
                    <div className='flex flex-col lg:flex-row justify-center'>
                        <p>Pod Břízkami 897</p>
                        <span className='font-normal ml-4'> / v ulici směrem Ke Krematoriu /</span>
                    </div>
                    <p>530 02 Pardubice V</p>
                </div>
            </div>
            <div className="mt-8 text-center">
                <h2 className="text-2xl">Jak se k nám dostat?</h2>
                <p>MHD linky s přestupy č.: 1, 2, 5, 6 , 8, 10, 12, 13, 21, 28, 88 - ze směru od
                    centra města na zastávku Zborovského náměstí, ze směru části města
                    Dubina na zastávku Krematorium.</p>
            </div>
            <div className="mt-8 text-center">
                <h2 className="text-2xl">Jaká je u nás možnost parkování?</h2>
                <p>
                    K dispozici jsou parkovací místa záchytného parkoviště Kasárna
                    T.G.Masaryka, kde vstup je zpoplatněn 5 Kč/den.
                    V omezené míře pak parkovací místa v bezprostřední blízkosti ordinace.
                    Parkovací plocha před budovou ordinace je určena především pro sanitní
                    vozy, které zajišťují dopravu imobilním pacientům.
                </p>
            </div>
            <div id="map" className="mt-4"> </div>
        </React.Fragment>

    return (<PageTemplate title="Kontakt" mainContent={mainContent}></PageTemplate>);
}

ReactDOM.render(<Contact></Contact>, document.getElementById('contact'));